module.exports = __webpack_public_path__ + "static/media/Gembah-VertSingleColor-Tagline0.d9524f00.png";